import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import Slide from "@mui/material/Slide";
import Button from "../button/button";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AlertDialogSlide(props) {
  let { open, onClose, onAgree, onDisAgree, description } = props;

  return (
    <div>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={onClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <div className="px-10 py-10">
          <DialogTitle>{props.title}</DialogTitle>
          <DialogContent>
            <DialogContentText
              style={{ fontSize: "15px" }}
              id="alert-dialog-slide-description"
            >
              {description}
            </DialogContentText>
          </DialogContent>
          <div className="flex flex-row justify-between mt-6">
            <Button
              customStyle="px-10 bg-[#FEBB12] hover:bg-[#FEBB12]  text-[white]"
              onClick={onDisAgree}
              name="Back"
            />
            <Button
              customStyle="px-10 bg-[#FEBB12] hover:bg-[#FEBB12] text-[white]"
              onClick={onAgree}
              name="Confirm"
            />
          </div>
        </div>
      </Dialog>
    </div>
  );
}
